<template>
	<div class="feedItem panel bg-lightest black">
		<div class="w-100 font-weight-600"><span class="ml-1">Next Departures</span></div>

		<router-link :to="{ name: 'calendar' }">
			<div v-if="isLoadingEvents"
				class="px-0 py-5 w-100 font-weight-600 medium d-flex align-items-end justify-content-center">
				<div class="fs-large mr-1">Loading</div>
				<loader size="small"></loader>
			</div>

			<div v-else-if="rows.length > 0" class="px-0 pt-4 d-flex h-100">
				<list class="w-100" :header="header" :body="body" :rows="rows" :actions="actions"></list>
			</div>

			<div v-else class="px-0 py-5 w-100 text-center font-weight-600 medium fs-larger">
				No data
			</div>
		</router-link>
	</div>
</template>

<script>
import List from '@/tools/list/baseList'
import { mapGetters, mapActions } from 'vuex'
import loader from '@/tools/loaders/loader1'

export default {
	created: function () {
		// *******************************
		// Requests API for today's events
		// needs to be changed for today only, not the month
		// testing
		// *******************************

		this.loadEvents();

		// sets time filter to paint the departures red, in this case the ones happening in the next hour.
		function isCloseToHappening(startHour) {
			let timefilter = moment().add(1, 'hour');
			let eventHour = moment(startHour, "h:mm");

			return eventHour.isBefore(timefilter);
		}

		// List Custom Cells
		var vm = this;
		this.body.customCells = {
			time: function (row) {
				var rowIndex = vm.rows.indexOf(row);

				if (isCloseToHappening(row.time)) {
					return '<span class="color-6 font-weight-600">' + row.time + '</span>';
				} else {
					return row.time
				}
			},
			event: function (row) {
				var rowIndex = vm.rows.indexOf(row);

				if (isCloseToHappening(row.time)) {
					return '<span class="color-6 font-weight-600">' + row.product + '</span>';
				} else {
					return row.product
				}
			},
			availability: function (row) {
				var rowIndex = vm.rows.indexOf(row);

				if (isCloseToHappening(row.time)) {
					return '<span class="color-6 font-weight-600">' + row.availability + '</span>';
				} else {
					return '<span class="font-weight-600">' + row.availability + '</span>';
				}
			},
			checkin: function (row) {
				var rowIndex = vm.rows.indexOf(row);

				if (isCloseToHappening(row.time)) {
					return '<span class="color-6 font-weight-600">' + row.checkin + '</span>';
				} else {
					return row.checkin
				}
			}
		};
	},
	data: function () {
		return {
			rows: [],
			header: {
				selection: {
					active: false,
					event: function (event) { }
				},
				list: {
					'time': 'Time',
					'event': 'Event',
					'availability': 'Availability',
					'checkin': 'Check-in'
				},
				customClassCell: {
					checkin: 'text-nowrap'
				}
			},
			body: {
				selection: {
					active: false,
					event: function (event) { }
				},
				customRowEvent: this.sharedRowEvent,
				customCells: null,
			},
			actions: {
				label: 'Actions',
				list: [],
			},
			isLoadingEvents: false
		}
	},
	props: {
		cardInfo: {
			type: Object
		}
	},
	computed: {
		...mapGetters([
			'getReservations',
			'getReservationsLabels',
			'account'
		])
	},
	methods: {
		...mapActions([
			'fetchUserDetails'
		]),
		loadEvents: function () {
			this.isLoadingEvents = true;
			try {
				axios.get('api/calendar/GetNextDepartures', {
					params: {
						supplierId: this.account.supplierId,
					}
				}).then(response => {
					if (response && response.status === 200 && response.data.events.length > 0) {
						this.populateCard(response.data.events);
						this.errorNoData = false;
					}
					this.isLoadingEvents = false;
				});
			}
			catch (error) {
				this.isLoadingEvents = false;
			}
		},
		populateCard: function (eventsArr) {
			var dataArr = [];

			for (let singleEvent of eventsArr) {
				let lotation = singleEvent.maximumLotation;
				let available = singleEvent.quantityAvailable;
				let checkins = singleEvent.checkins;
				let stringCheckins = checkins + '/' + (lotation - available);

				dataArr.push({
					'time': singleEvent.time,
					'event': singleEvent.productName,
					'product': singleEvent.productName,
					'availability': singleEvent.quantityAvailable,
					'checkin': stringCheckins
				});
			}

			this.rows = dataArr;
		}
	},
	components: {
		List,
		loader
	}
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/_variables.scss';

.feedItem {
	height: auto !important;
}
</style>



// WEBPACK FOOTER //
// FeedcardDepartures.vue?ce211b28